
'use strict';


const _ = require('underscore')

const LETTER_PAGE_WIDTH = 8.5;
const LETTER_PAGE_HEIGHT = 11;
const A4_PAGE_WIDTH = 8.27;
const A4_PAGE_HEIGHT = 11.69;
const DPI = 72;

exports.LETTER_PAGE_WIDTH = LETTER_PAGE_WIDTH;
exports.LETTER_PAGE_HEIGHT = LETTER_PAGE_HEIGHT;
exports.A4_PAGE_WIDTH = A4_PAGE_WIDTH;
exports.A4_PAGE_HEIGHT = A4_PAGE_HEIGHT;
exports.DPI = DPI;

var TEAR_SHEET_TEMPLATE = `
<style type="text/css" scoped>
[FONTS/]
.page {
    background-color: [BACKGROUND_COLOR/];
    color: [TEXT_DEFAULT_COLOR/];
    font-family: [TEXT_DEFAULT_FONT_FAMILY/];
    font-size: [TEXT_DEFAULT_FONT_SIZE/];
}
.title {
    font-size: 3em;
    color: [ACCENT_COLOR/];
    font-family: [TITLE_FONT_FAMILY/];
}
.product-image {
    background-size: [IMAGE_SIZE/];
    background-repeat: no-repeat; 
    background-position: center center;
}
.additional-image {
    width: [ADDITIONNAL_IMAGE_WIDTH/];
    height: [ADDITIONNAL_IMAGE_HEIGHT/];
}
.header, .footer {
    font-size: 1.5em;
}
.price {
    font-size: 2em;
}
</style>

<div class="page" style="
position: relative; 
font-size: 5pt;
width: 612px; 
height: 792px; ">
    <div class="page-content" style="position: absolute; top: 32px; left: 54px; right: 54px; bottom: 32px">
        <div class="header" style="position: absolute; top: 0; left: 0; width: 100%; height: 50px;">
            <div style="width: 20%; height: 100%; float: left">
            </div>
            <div style="width: 60%; height: 100%; float: left; line-height: 50px; text-align: center">
            [HEADER_LOGO/] [HEADER_NAME/] [HEADER_WEBSITE/] [HEADER_ADDRESS/] [HEADER_PHONE_NUMBER/] [HEADER_CONTACT_EMAIL/]</div>
        </div>
        <div class="main-image" style="position: absolute; top: 70px; left: 0; width: 73%; height: 440px;">
            [MAIN_IMAGE/]
        </div>
        <div class="additional-images" style="position: absolute; top: 70px; right: 0; width: 25%; height: 440px;">
            [ADDITIONAL_IMAGES/]
        </div>
        <div class="information" style="position: absolute; top: 520px; right: 0; width: 100%; height: 155px;">
            <span class="title">[TITLE]?<br>[/TITLE]</span>
            <span>[SKU]?<br>[/SKU]</span>
            <span>[VARIATIONS]?<br>[/VARIATIONS]</span>
            <span>[ADDITIONAL_FIELDS]?<br>[/ADDITIONAL_FIELDS]</span>
            <span>[DESCRIPTION]?<br>[/DESCRIPTION]</span>
            <span class="price">[PRICE]?<br>[/PRICE]</span>
        </div>
        <div class="footer" style="position: absolute; bottom: 0; left: 0; width: 100%; height: 25px;">
            <div style="width: 5%; height: 100%; position: absolute; left: 0;">
                [FOOTER_LOGO/]
            </div>
            <div style="width: 100%; height: 100%; text-align: center; position: absolute; right: 0; line-height: 25px; white-space:nowrap;">[FOOTER_NAME/] [FOOTER_WEBSITE/] [FOOTER_ADDRESS/] [FOOTER_PHONE_NUMBER/] [FOOTER_CONTACT_EMAIL/]</div>
            <div style="width: 5%; height: 100%;  position: absolute; right: 0;">

            </div>
        </div>
    </div>
    `
exports.TEAR_SHEET_TEMPLATE = TEAR_SHEET_TEMPLATE;

function buildFontText(font) {
  if (font && font.files && font.files[font.style]) {
    return `@font-face {
            font-family: '${font.family}';
            src: url(${font.files[font.style]});
        }`
  }
  return '';
}

function formatMoney(price, precision, decimalSeparator, hundredsSeparator) {
  var precision = isNaN(precision = Math.abs(precision)) ? 2 : precision,
    decimalSeparator = decimalSeparator == undefined ? "." : decimalSeparator,
    hundredsSeparator = hundredsSeparator == undefined ? "," : hundredsSeparator,
    s = price < 0 ? "-" : "",
    i = String(parseInt(price = Math.abs(Number(price) || 0).toFixed(precision))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return s + (j ? i.substr(0, j) + hundredsSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + hundredsSeparator) + (precision ? decimalSeparator + Math.abs(price - i).toFixed(precision).slice(2) : "");
};

// 20190415204743
// https://gist.githubusercontent.com/Fluidbyte/2973986/raw/b0d1722b04b0a737aade2ce6e055263625a0b435/Common-Currency.json

const CURRENCY_SYMBOLS = {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos"
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "CO$",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "Dkr",
    "name": "Danish Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Sheqel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new sheqels"
  },
  "INR": {
    "symbol": "Rs",
    "name": "Indian Rupee",
    "symbol_native": "টকা",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "LD",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "Nkr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/.",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "Skr",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.F.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.F.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  }
}

exports.buildTearSheet = function (locale, template, user, listing) {

  var preview;
  var tearSheet = user.tear_sheet;
  if (tearSheet.html) {
    preview = replaceUserInformation(replaceListingInformation(locale, replaceImages(tearSheet.html, listing), listing), user, 1);
  } else {
    var additionalImages = '';
    var variations;
    if (!tearSheet.background_color) {//not initialized
      tearSheet.background_color = '#ffffff';
      tearSheet.header_fields = ['logo']
      tearSheet.footer_fields = ['name', 'address', 'phone_number', 'contact_email']
      tearSheet.title_font = {
        family: 'Open Sans',
        size: '11px',
        style: 'regular'
      };
      tearSheet.text_default_font = {
        family: 'Open Sans',
        size: '24px',
        style: 'regular'
      };
      tearSheet.additional_images_max_columns = 1;
      tearSheet.additional_images_max_rows = 4;
      tearSheet.product_fields = ['title', 'price', 'sku', 'description', 'variants'];
      tearSheet.images_size = 'contain';
      tearSheet.accent_color = '#0e78d2';
      tearSheet.text_default_color = '#000000';
    }


    var imagesSize = tearSheet.images_size;
    var width = 100 / tearSheet.additional_images_max_columns;
    var height = 100 / tearSheet.additional_images_max_rows;
    if (listing.images) {
      var maxImages = tearSheet.additional_images_max_rows * tearSheet.additional_images_max_columns;
      for (let i = 0; i < Math.min(maxImages, listing.images.length - 1); i++) {
        let image = listing.images[i + 1];
        additionalImages += `<div  class="product-image additional-image" style="background-image: url('${image}'); float: left;"></div>`;
      };
    }
    listing.variations.forEach((variation) => {
      let options = variation.options;
      variations += options.join(', ') + '<br/>';
    });

    var headerFields = tearSheet.header_fields;
    var footerFields = tearSheet.footer_fields;
    var productFields = tearSheet.product_fields;
    var businessProfile = user.business_profile;
    let content = {
      //header
      HEADER_LOGO: checkField(headerFields, 'logo', businessProfile.logo_url ? `<img src="${businessProfile.logo_url}" style="height: 100%">` : ''),
      HEADER_NAME: checkField(headerFields, 'name', businessProfile.name),
      HEADER_WEBSITE: checkField(headerFields, 'website', businessProfile.website),
      HEADER_ADDRESS: checkField(headerFields, 'address', businessProfile.address),
      HEADER_PHONE_NUMBER: checkField(headerFields, 'phone_number', businessProfile.phone_number),
      HEADER_CONTACT_EMAIL: checkField(headerFields, 'contact_email', businessProfile.contact_email),

      //footer
      FOOTER_LOGO: checkField(footerFields, 'logo', businessProfile.logo_url ? `<img src="${businessProfile.logo_url}" style="height: 100%">` : ''),
      FOOTER_NAME: checkField(footerFields, 'name', businessProfile.name),
      FOOTER_WEBSITE: checkField(footerFields, 'website', businessProfile.website),
      FOOTER_ADDRESS: checkField(footerFields, 'address', businessProfile.address),
      FOOTER_PHONE_NUMBER: checkField(footerFields, 'phone_number', businessProfile.phone_number),
      FOOTER_CONTACT_EMAIL: checkField(footerFields, 'contact_email', businessProfile.contact_email),

      MAIN_IMAGE: `<div class="product-image" style="background-image: url('${listing.main_image}'); height: 100%; width: 100%"></div>`,
      PRICE: checkField(productFields, 'price', businessProfile.money_format.replace('{{amount}}', '' + formatMoney(listing.price))),
      ADDITIONAL_IMAGES: additionalImages,
      VARIATIONS: checkField(productFields, 'variations', variations),
      ADDITIONAL_FIELDS: '',
      TITLE: checkField(productFields, 'title', listing.title),
      DESCRIPTION: checkField(productFields, 'description', listing.description),
      SKU: checkField(productFields, 'sku', listing.sku),

      //style
      FONTS: buildFontText(tearSheet.text_default_font) + buildFontText(tearSheet.title_font),
      IMAGE_SIZE: tearSheet.images_size,
      ADDITIONNAL_IMAGE_WIDTH: 100 / tearSheet.additional_images_max_columns + '%',
      ADDITIONNAL_IMAGE_HEIGHT: 100 / tearSheet.additional_images_max_rows + '%',
      BACKGROUND_COLOR: tearSheet.background_color,
      TEXT_DEFAULT_COLOR: tearSheet.text_default_color,
      TEXT_DEFAULT_FONT_SIZE: tearSheet.text_default_font.size,
      TEXT_DEFAULT_FONT_FAMILY: tearSheet.text_default_font.family,
      TITLE_FONT_SIZE: tearSheet.title_font.size,
      TITLE_FONT_FAMILY: tearSheet.title_font.family,
      ACCENT_COLOR: tearSheet.accent_color
    }
    preview = TEAR_SHEET_TEMPLATE;
    for (let key in content) {
      var regex = `\\[${key}\\](.*)\\?(.*)\\[/${key}\\]`;
      var re = new RegExp(regex, 'g');
      preview = preview.replace(re, content[key] ? `$1${content[key]}$2` : '');

      preview = preview.replace(`[${key}/]`, content[key]);
    }
  }
  return preview;
};



exports.buildDocument = function (locale, html, user, listing) {
  return replaceUserInformation(replaceListingInformation(locale, replaceQRCode(replaceBarcode(replaceImages(html, listing), listing), listing), listing), user, 1);
};


exports.buildOrderSheet = function (locale, template, user, listings, pageNumber) {
  return replaceUserInformation(replaceListingTable(locale, template, listings), user, pageNumber);
};


function checkField(fields, field, returnValue) {
  return fields.indexOf(field) > -1 ? (returnValue || '') : '';
}

exports.createImagesTemplate = function (state) {

  var additionalImages = '';
  var backgroundSize = state.style['background-size'];
  var width = 100 / state.additional_images_max_columns;
  var height = 100 / state.additional_images_max_rows;
  var maxImages = state.additional_images_max_rows * state.additional_images_max_columns;
  for (let i = 0; i < maxImages; i += 1) {
    additionalImages += `
            <div style="
                    background-repeat: no-repeat; 
                    background-position: center center; 
                    background-image: url('[LISTING_IMAGE_${i}]');
                    background-size: ${backgroundSize};
                    width: ${width}%; 
                    height: ${height}%;
                    float: left;">
            </div>`;
  }

  var mainImageWidth = (maxImages === 0) ? '100%' : '73%';
  var sideImageWidth = (maxImages === 0) ? '0%' : '25%';
  return `
        <div style="position: absolute; top: 0; left: 0; width: ${mainImageWidth}; height: 100%;">
        <div style=" background-repeat: no-repeat; background-position: center center; background-size: ${backgroundSize}; background-image: url('[LISTING_MAIN_IMAGE]'); height: 100%; width: 100%"></div>
        </div>
        <div style="position: absolute; top: 0; right: 0; width: ${sideImageWidth}; height: 100%;">
            ${additionalImages}
        </div>
    `;
};

function buildBorders(style) {
  var html = '';

  if (style['border-left-color'])
    html += 'border-left-color:' + style['border-left-color'] + ';';

  if (style['border-right-color'])
    html += 'border-right-color:' + style['border-right-color'] + ';';

  if (style['border-top-color'])
    html += 'border-top-color:' + style['border-top-color'] + ';';

  if (style['border-bottom-color'])
    html += 'border-bottom-color:' + style['border-bottom-color'] + ';';

  html += 'border-left-width:' + (style['border-left-width'] || 0) + ';';
  html += 'border-right-width:' + (style['border-right-width'] || 0) + ';';
  html += 'border-top-width:' + (style['border-top-width'] || 0) + ';';
  html += 'border-bottom-width:' + (style['border-bottom-width'] || 0) + ';';

  html += 'border-style: solid;';
  return html;
}

function getTableHeight(maxRows) {
  return (100 / (maxRows + 1)) + '%';
}

exports.createTableTemplate = function (state) {

  var height = getTableHeight(state.max_rows);
  var html = '<div style="display: table; width: 100%; height: 100%; border-collapse: collapse">';
  // html += '<div style="display: table-header-group; width: 100%; height: 30%">';
  html += '<div style="display: table-row; width: 100%; height: auto">';
  state.columns.forEach(function (column) {
    html += '<div style="display: table-cell; padding: 1%; overflow: hidden; vertical-align: middle;' + buildBorders(column.style) + 'width:' + column.style.width + '">';
    html += column.header_html;
    html += '</div>';
  });
  // html += '</div>';
  html += '</div>';
  // html += '<div style="display: table-row-group; width: 100%; height: 70%">';
  for (let i = 0; i < state.max_rows; i += 1) {
    html += '{% ROW_' + i + ' %}';
    html += '<div style="display: table-row; width: 100%; border: none; height:auto;">';
    state.columns.forEach(function (column) {
      html += '<div style="display: table-cell; height: inherit; padding: 1%; vertical-align: middle;' + buildBorders(column.style) + 'width:' + column.style.width + '">';
      html += column.content_html;
      html += '</div>';
    });
    html += '</div>';
    html += '{% END_ROW_' + i + ' %}';
  }
  // html += '</div>';
  html += '</div>';

  return html;
};

function replaceAll(content, key, value) {
  return content.replace(new RegExp(key, 'g'), value);
}

function returnBarcodeUrl(type, listing) {
  if (listing.barcode && listing.barcode.length > 0) {
    return '<img style="max-width: 100%; max-height: 100%; height: 1em" src="http://barcode.nowinstore.com?bcid=' + type + '&text=' + encodeURIComponent(listing.barcode) + '&backgroundcolor=FFFFFF&includetext&paddingwidth=2&paddingheight=2"/>';
  }
  return '';
}

function valueOrEmptyString(value) {

  return value ? value : '';
}
function stripHTML(html) {
  return html ? html.replace(/<(?:.|\n)*?>/gm, '') : '';
}

function stripCSS(html) {
  return html.replace(/<([^>]*)(\sstyle=\".+?\"(\s|))(.*?)>/gi, '');
}
function stripLinks(html) {
  return html.replace(/<\/?a.*?>/gi, '');
}

var replaceImages = function (html, listing) {
  var returnedHtml = html;
  returnedHtml = replaceAll(returnedHtml, '\\[LISTING_MAIN_IMAGE\\]', listing.main_image);
  if (listing.images) {
    for (var i = 1; i < listing.images.length; i += 1) {
      returnedHtml = replaceAll(returnedHtml, `\\[LISTING_IMAGE_${i - 1}\\]`, listing.images[i]);
    }
  }
  returnedHtml = replaceAll(returnedHtml, `\\[LISTING_IMAGE_.*\\]`, '');

  return returnedHtml;
};
exports.replaceImages = replaceImages;

var replaceUserInformation = function (html, user, pageNumber) {
  return html
    .replace('[BUSINESS_LOGO]', user.business_profile.logo_url ? `<img src="${user.business_profile.logo_url}" style="height: 1em" />` : '')
    .replace('[BUSINESS_NAME]', user.business_profile.name || '')
    .replace('[BUSINESS_ADDRESS]', user.business_profile.address || '')
    .replace('[BUSINESS_ADDRESS2]', user.business_profile.address2 || '')
    .replace('[BUSINESS_CITY]', user.business_profile.city || '')
    .replace('[BUSINESS_ZIP_CODE]', user.business_profile.zip_code || '')
    .replace('[BUSINESS_STATE_PROVINCE]', user.business_profile.state_province || '')
    .replace('[BUSINESS_COUNTRY]', user.business_profile.iso_country_code || '')
    .replace('[BUSINESS_WEBSITE]', user.business_profile.website || '')
    .replace('[BUSINESS_PHONE_NUMBER]', user.business_profile.phone_number || '')
    .replace('[BUSINESS_CONTACT_EMAIL]', user.business_profile.contact_email || '')
    .replace('[PAGE_NUMBER]', pageNumber || '');
}
exports.replaceUserInformation = replaceUserInformation;


function formatPrice(locale, listing, price) {
  return new Intl.NumberFormat(locale, { style: 'currency', currency: listing.iso_currency_code || 'USD' }).format(price);
}



function replaceMetafields(reg, value, data) {
  const newTargetText = value.replace(reg, function (match) {
    const ids = match.replace('[', '').replace(']', '').toLowerCase().split('.');
    if (ids.length > 0) {
      const namespace = ids[1];
      const key = ids[2];
      const metafield = _.findWhere(data.metafields, { namespace: namespace, key: key });
      if (metafield) {
        return metafield.value;
      }
    }
    return '';
  });
  return newTargetText;
}

var replaceListingInformation = function (locale, html, listing) {
  var description = '';
  try {
    description = valueOrEmptyString(stripLinks(stripCSS(listing.description)));
  } catch (e) {

  }
  var int_price = Math.floor(listing.price);
  var decimal_price = Math.round((listing.price - Math.floor(listing.price)) * 100);
  var int_msrp = Math.floor(listing.suggested_retail_price);
  var decimal_msrp = Math.round((listing.suggested_retail_price - Math.floor(listing.suggested_retail_price)) * 100);
  var currencySymbol = CURRENCY_SYMBOLS[listing.iso_currency_code];
  var symbol = currencySymbol ? currencySymbol.symbol_native : '';
  var barcode = listing.barcode || '';
  var listingCompareAtPrice = listing.compare_at_price;
  var intCompareAtPrice = Math.floor(listingCompareAtPrice);

  var decimalCompareAtPrice = Math.round((listingCompareAtPrice - Math.floor(listingCompareAtPrice)) * 100);
  if (decimalCompareAtPrice < 10) {
    decimalCompareAtPrice = '0' + decimalCompareAtPrice;
  }

  var html = html
    .replace('[TITLE]', valueOrEmptyString(stripHTML(listing.title)))
    .replace('[URL]', listing.url)
    .replace('[DESCRIPTION]', description)
    .replace('[SKU]', listing.sku || '')
    .replace('[VARIANT_OPTION_TITLE]', (listing.default_variant_option && listing.default_variant_option.title) ? listing.default_variant_option.title.replace('Default Title', '') : '')
    .replace('[MAIN_IMAGE]', listing.main_image ? '<div style="max-height: 100%; max-width: 100%; height: 100%; width: 100%; background-repeat: no-repeat; background-position: center center; background-image: url(' + listing.main_image + '); background-size: contain"></div>' : '')
    .replace('[MAIN_IMAGE_COVER]', listing.main_image ? '<div style="max-height: 100%; max-width: 100%; height: 100%; width: 100%; background-repeat: no-repeat; background-position: center center; background-image: url(' + listing.main_image + '); background-size: cover"></div>' : '')
    .replace('[QRCODE]', listing.url ? '<img style="max-width: 100%; max-height: 100%;height: 1em" src="http://barcode.nowinstore.com?bcid=qrcode&text=' + encodeURIComponent(listing.url) + '&backgroundcolor=FFFFFF&paddingwidth=2&paddingheight=2"/>' : '')
    .replace('[BARCODE_DATA]', barcode)
    .replace('[BARCODE]', returnBarcodeUrl('code39', listing))
    .replace('[BARCODE_39]', returnBarcodeUrl('code39', listing))
    .replace('[BARCODE_EAN8]', returnBarcodeUrl('ean8', listing))
    .replace('[BARCODE_EAN13]', returnBarcodeUrl('ean13', listing))
    .replace('[BARCODE_UPCA]', returnBarcodeUrl('upca', listing))
    .replace('[BARCODE_UPCE]', returnBarcodeUrl('upce', listing))
    .replace('[BARCODE_ITF14]', returnBarcodeUrl('itf14', listing))
    .replace('[BARCODE_128]', returnBarcodeUrl('code128', listing))
    .replace('[STOCK]', '' + listing.stock || '0')
    .replace('[CURRENCY]', symbol)
    .replace('[PRICE(INT)]', '' + int_price || '')
    .replace('[PRICE(DECIMAL)]', '' + decimal_price || '')
    .replace('[LISTING_URL]', listing.url)
    .replace('[PRICE]', listing.price === 0 ? '' : formatPrice(locale, listing, listing.price))
    .replace('[MSRP(INT)]', int_msrp || '')
    .replace('[MSRP(DECIMAL)]', decimal_msrp || '')
    .replace('[MSRP]', listing.suggested_retail_price === 0 ? '' : formatPrice(locale, listing, listing.suggested_retail_price))
    .replace('[VENDOR]', listing.vendor)
    .replace('[COMPARE_AT_PRICE(INT)]', intCompareAtPrice || '')
    .replace('[COMPARE_AT_PRICE(DECIMAL)]', decimalCompareAtPrice || '')
    .replace('[COMPARE_AT_PRICE]', listing.compare_at_price === 0 ? '' : formatPrice(locale, listing, listing.compare_at_price));
  html = replaceMetafields(/([LISTING\.[[A-Z_\d]+\.[A-Z_\d]+])/g, html, listing);

  var res = html.match(/\[VARIANTS\(([^\]]*)\)\]/);
  var price = listing.price;
  if (!listing.variations) {
    if (res && res.length > 0) {
      html = html.replace(res[0], '');
    }
  } else {
    var priceMustBeDisplayed = false;
    var pricesAreTheSame = true;
    if (res && res.length > 0) {
      var variations = listing.variations;
      var variationDescription = '';
      for (var v = 0; v < variations.length; v += 1) {
        var options = variations[v].options;
        if (options && options.length > 0) {
          var params = ['TITLE']; //default display
          if (res.length > 1) {
            params = res[1].split(', ');
          }
          var optionsDescription = '';
          var shouldDisplayAsTable = params.indexOf('TABLE') !== -1;
          price = options[0].price;
          var k;
          for (k = 0; k < options.length && pricesAreTheSame; k += 1) {
            pricesAreTheSame = (price === options[k].price);
          }
          priceMustBeDisplayed = params.indexOf('PRICE') !== -1;

          if (shouldDisplayAsTable) {
            optionsDescription += '<div style="display: table">';
          }
          for (var i = 0; i < options.length; i += 1) {
            var option = options[i];
            if (shouldDisplayAsTable) {
              optionsDescription += '<div style="display: table-row">';
            }

            for (var j = 0; j < params.length; j += 1) {
              var paramOptionsDescription = '';
              var isEmpty = false;
              if (shouldDisplayAsTable) {
                paramOptionsDescription += '<div style="display: table-cell; padding: 2px;">';
              } else {
                if (j > 0) {
                  paramOptionsDescription += '&nbsp;';
                }
              }
              var optionPrice = option.price;
              var optionIntPrice = Math.floor(optionPrice);
              var optionDecimalPrice = Math.floor((optionPrice - parseInt(optionPrice)) * 100);
              // var optionMsrp = option.suggested_retail_price;
              switch (params[j].trim()) {
                case 'TITLE':
                  if (option.title !== 'Default Title' && option.title !== 'Default') {
                    paramOptionsDescription += stripHTML(option.title);
                  } else {
                    isEmpty = true;
                  }
                  break;
                case 'PRICE':
                  if (!pricesAreTheSame) {
                    paramOptionsDescription += '<b>' + symbol + parseFloat(optionPrice).toFixed(2) + '</b>';
                  }
                  break;
                case 'PRICE(DECIMAL)':
                  if (!pricesAreTheSame) {
                    paramOptionsDescription += '<b>' + optionDecimalPrice + ((optionDecimalPrice < 10) ? '0' : '') + '</b>';
                  }
                  break;
                case 'PRICE(INT)':
                  if (!pricesAreTheSame) {
                    paramOptionsDescription += '<b>' + optionIntPrice + '</b>';
                  }
                  break;
                // case 'MSRP':
                //     if (!msrpAreTheSame) {
                //         paramOptionsDescription += '<b>' + formatPrice(locale, listing, optionMsrp) + '</b>';
                //     }
                //     break;
                // case 'MSRP(DECIMAL)':
                //     if (!msrpAreTheSame) {
                //         paramOptionsDescription += '<b>' + decimal_msrp + '</b>';
                //     }
                //     break;
                // case 'MSRP(INT)':
                //     if (!msrpAreTheSame) {
                //         paramOptionsDescription += '<b>' + int_msrp + '</b>';
                //     }
                //     break;
                // case 'COMPARE_AT_PRICE':
                //     if (!compareAtPricesAreTheSame) {
                //         paramOptionsDescription += '<b>' + formatPrice(locale, listing, compareAtPrice) + '</b>';
                //     }
                //     break;
                // case 'COMPARE_AT_PRICE(DECIMAL)':
                //     if (!compareAtPricesAreTheSame) {
                //         paramOptionsDescription += '<b>' + decimalCompareAtPrice + '</b>';
                //     }
                //     break;
                // case 'COMPARE_AT_PRICE(INT)':
                //     if (!compareAtPricesAreTheSame) {
                //         paramOptionsDescription += '<b>' + intCompareAtPrice + '</b>';
                //     }
                //     break;
                case 'CURRENCY':
                  if (!pricesAreTheSame) {
                    paramOptionsDescription += '<b>' + symbol + '</b>';
                  }
                  break;
                case 'SKU':
                  if (option.sku) {
                    paramOptionsDescription += option.sku;
                  }
                  break;
                case 'BARCODE_DATA':
                  if (option.barcode) {
                    paramOptionsDescription += barcode;
                  }
                  break;
                case 'BARCODE':
                case 'BARCODE_39':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('code39', listing);
                  }
                  break;
                case 'BARCODE_EAN8':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('ean8', listing);
                  }
                  break;
                case 'BARCODE_EAN13':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('ean13', listing);
                  }
                  break;
                case 'BARCODE_UPCA':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('upca', listing);
                  }
                  break;
                case 'BARCODE_UPCE':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('upce', listing);
                  }
                  break;
                case 'BARCODE_ITF14':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('itf14', listing);
                  }
                  break;
                case 'BARCODE_128':
                  if (option.barcode) {
                    paramOptionsDescription += returnBarcodeUrl('code128', listing);
                  }
                  break;
                case 'STOCK':
                  if (option.stock) {
                    paramOptionsDescription += 'Stock: ' + option.stock;
                  }
                  break;
                case 'TABLE':
                  break;
                default:
                  paramOptionsDescription += replaceMetafields(/(VARIANT\.[[A-Z]+\.[A-Z]+)/g, params[j].trim(), option);
                  break;
              }
              if (shouldDisplayAsTable) {
                paramOptionsDescription += '</div>';
              }
              if (!isEmpty) {
                optionsDescription += paramOptionsDescription;
              }
            }
            if (shouldDisplayAsTable) {
              optionsDescription += '</div>';
            } else {
              if (i < options.length - 1) {
                optionsDescription += '&nbsp;&#8226; ';
              }
            }
          }
          if (shouldDisplayAsTable) {
            optionsDescription += '</div>';
          }
          variationDescription += optionsDescription;
        }
      }
      if (priceMustBeDisplayed && pricesAreTheSame) {
        variationDescription += symbol + parseFloat(listing.price).toFixed(2);
        // if (msrpMustBeDisplayed && msrpAreTheSame) {
        //     html += ' / S.R. Price: <b>' + formatPrice(locale, listing, listing.suggested_retail_price) + '</b>';
        // }
      }
      html = html.replace(res[0], variationDescription);
    }
  }

  return html;
};
exports.replaceListingInformation = replaceListingInformation;


function getMaxRows(html) {
  return (html.match(new RegExp('{%\\sROW_\\d*\\s%}', 'g')) || []).length;
}
exports.getMaxRows = getMaxRows;

function replaceListingTable(locale, html, listings) {
  listings.forEach(function (listing, index) {
    html = replaceImages(replaceListingInformation(locale, html, listing), listing);
  });
  var maxRows = getMaxRows(html);
  var limit = Math.min(maxRows, listings.length);
  var height = getTableHeight(maxRows);
  var re;
  var regexp;
  for (var i = 0; i < limit; i++) {
    // html = html.replace('[LISTING_VISIBILITY_'+i+']', '1');
    re = '{%\\sROW_' + i + '\\s%}';
    regexp = new RegExp(re);
    html = html.replace(regexp, '');

    re = '{%\\sEND_ROW_' + i + '\\s%}';
    regexp = new RegExp(re);
    html = html.replace(regexp, '');
  }
  //cleanup

  for (var i = limit; i < maxRows; i++) {
    var re = '{%\\sROW_' + i + '\\s%}.*{%\\sEND_ROW_' + i + '\\s%}';
    var regexp = new RegExp(re);
    html = html.replace(regexp, '<div style="display: table-row; width: 100%; height: auto;"></div>');
  }
  return html;
}
exports.replaceListingTable = replaceListingTable;


exports.initListingsCategories = function (catalog) {
  catalog.listings = [];
  catalog.categories = [];
  catalog.pages.forEach((page) => {
    let header = page.header.properties.html;
    let category = header ? header.replace(/<[^>]*>/g, '').trim() : '';
    let hasListings = false;
    page.elements.forEach((element, index) => {
      if (element.type === 'application/product' && index < page.layout.cells.length &&
        page.layout.cells[index].accepts.indexOf('application/product') > -1) {
        hasListings = true;
        let listing = element.properties;
        listing.hasVariants = false;
        if (listing.variations) {
          listing.variations.forEach((variation) => {
            variation.options.forEach((option) => {
              listing.hasVariants = true;
            });
          })
        }
        listing.category = category;
        catalog.listings.push(listing);
      }
    })
    if (hasListings && header && !catalog.categories.includes(category)) {
      catalog.categories.push(category);
    }
  });
}

exports.toPx = function (size) {
  return DPI * size;
}

exports.createBarcodeTemplate = function (state) {
  var params = '';
  if (state.display_text) {
    params += '&includetext'
  }
  params += '&scaleX=' + (state.scale_x || 2);
  params += '&scaleY=' + (state.scale_y || 2);
  return `<div style="width: 100%; height: 100%; background-size: contain; background-repeat: no-repeat; background-position: center center;
  background-image: url('http://barcode.nowinstore.com?bcid=${state.type}&text=[BARCODE]&backgroundcolor=FFFFFF&paddingwidth=2&paddingheight=2${params}')"></div>`;
}
function replaceBarcode(html, listing) {
  return html.replace('[BARCODE]', listing.barcode)
}
exports.replaceBarcode = replaceBarcode;

exports.createQRCodeTemplate = function (state) {
  var params = '';
  return `<div style="width: 100%; height: 100%; background-size: contain; background-repeat: no-repeat; background-position: center center;
  background-image: url('http://barcode.nowinstore.com?bcid=qrcode&text=[LISTING_URL]')"></div>`;
}
function replaceQRCode(html, listing) {
  if (listing.url) {
    return html.replace('[LISTING_URL]', encodeURIComponent(listing.url));
  }
  return html;
}

exports.replaceQRCode = replaceQRCode;